export type CleanupPromptArgs = {
  featureName: string;
  featureKey: string;
};

const cleanupPromptBaseUrl = "https://prompt.link";

const cleanupIntroduction =
  "Clean up the fully rolled-out feature flag below by assuming the flag is permanently ON and removing the OFF path completely.";
const cleanupTasks = [
  "Tasks:",
  "- Find all references to the flag and keep only the ON path",
  "- Remove all dead code created by deleting the OFF path",
  "- Recursively remove now-unused components, hooks, props, types, imports, utilities, tests, styles, analytics, API params, and files",
  "- Simplify React / React Native component trees, state flow, context, navigation, and shared helpers affected by the removal",
  "- Update tests to cover only the surviving behavior",
  "- Delete rollout-specific comments, wrappers, and temporary abstractions",
  "- Ensure no references to the flag remain anywhere",
  "",
  "Be aggressive about cleanup: if something existed only to support the old branch, remove it.",
];

// Native Linear templates get their flag identity appended at issue creation.
export const linearCleanupTemplateInstructions = [
  cleanupIntroduction,
  "",
  ...cleanupTasks,
].join("\n");

export function getCleanupPrompt({
  featureName,
  featureKey,
}: CleanupPromptArgs): string {
  return [
    cleanupIntroduction,
    "",
    "Feature:",
    `- Name: ${featureName}`,
    `- Key: ${featureKey}`,
    "",
    ...cleanupTasks,
  ].join("\n");
}

export function getCleanupPromptLink(args: CleanupPromptArgs): string {
  const prompt = getCleanupPrompt(args);
  return `${cleanupPromptBaseUrl}?p=${encodeURIComponent(prompt)}`;
}
